import { render, staticRenderFns } from "./no_statistics_submitted.vue?vue&type=template&id=328097f8&scoped=true&"
import script from "./no_statistics_submitted.vue?vue&type=script&lang=js&"
export * from "./no_statistics_submitted.vue?vue&type=script&lang=js&"
import style0 from "./no_statistics_submitted.vue?vue&type=style&index=0&id=328097f8&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "328097f8",
  null
  
)

export default component.exports